import liff from '@line/liff'
import mixpanel from 'mixpanel-browser'

import API from '@/api'
import {
  addDatadogGlobalContext,
  getUserLocalStorage,
  sendDatadogLog,
  updateUserLocalStorage,
} from '@/utils'

export const state = {
  token: null,
  userId: null,
  expireTime: 0,
}
export const actions = {
  async customerCheck({ commit }, { code, phoneE164, lineToken }) {
    const result = await API.customerCheck({ code, phoneE164, lineToken })

    // 使用 LIFF 瀏覽器要直接登入
    const isLiffBrowser = liff.isInClient()
    const isLiffUser = isLiffBrowser && result?.exists && lineToken
    if (result.status === 'SUCCESS' && isLiffUser) {
      commit('setLogin', {
        result: { status: result.status, ...result.loginInfo },
        code,
      })
    }
    return result
  },
  async login(
    { commit },
    { code, phoneE164, password, lineUserId = null, avatar = null },
  ) {
    const result = await API.login({
      code,
      phoneE164,
      password,
      lineUserId,
      avatar,
    })
    commit('setLogin', { result, code })
    return result
  },
  async autoLogin({ commit }, { code }) {
    commit('setLoginInfo', { code })
  },
  async register({ commit }, { registerInfo, code }) {
    const result = await API.register({ registerInfo, code })
    commit('setLogin', { result, code })
    return result
  },
  async sendValidateCode(
    _,
    {
      phoneNumber,
      regionCode = 'TW',
      code,
      sendType = 'sms',
      smsSupplier = 'paasoo',
    },
  ) {
    const result = await API.sendValidateCode({
      phoneNumber,
      regionCode,
      code,
      sendType,
      smsSupplier,
    })
    if (result?.status === 'SUCCESS' && result?.code) {
      sendDatadogLog({
        message: '寄送驗證碼(測試)',
        data: { phoneNumber, regionCode, code, sendType, smsSupplier, result },
        status: 'debug',
      })
    }
    return result
  },
  async validatePhoneNumber(_, { phoneNumber, regionCode, smsCode, code }) {
    const result = await API.validatePhoneNumber({
      phoneNumber,
      regionCode,
      smsCode,
      code,
    })
    return result
  },
  async validateToken(_, { authToken, password, code }) {
    const result = await API.validateToken({ authToken, password, code })
    return result
  },
  async getLineLoginLink(_, { code }) {
    const params = new URLSearchParams(window.location.search)
    if (params.has('status')) {
      params.delete('status')
    }
    if (params.has('msg')) {
      params.delete('msg')
    }
    const result = await API.getLineLoginLink({
      code,
      destinationURI: `${window.location.pathname}?${params.toString()}`,
    })
    return result
  },
  async renewToken({ commit }, { code }) {
    const result = await API.renewToken({ code })
    commit('setLogin', { result, code })
    return result
  },
}

export const mutations = {
  setLogin(state, { result, code }) {
    const {
      status = '',
      token = null,
      expireTime = 0,
      userId = null,
      gender = null,
      sourceId = null,
    } = result
    if (status === 'SUCCESS') {
      state.token = token
      state.expireTime = expireTime
      state.userId = userId
      state.gender = gender
      state.sourceId = sourceId
      if (sourceId) {
        mixpanel.identify(sourceId)
        mixpanel.people.set({
          customer_gender: gender.toLowerCase(),
        })
      }
      addDatadogGlobalContext({ key: 'userId', value: userId })
      updateUserLocalStorage({ cname: code, data: { ...result } })
    }
  },
  setLoginInfo(state, { code }) {
    const userData = getUserLocalStorage({ cname: code })
    if (userData) {
      state.token = userData.token
      state.expireTime = userData.expireTime
      state.userId = userData.userId
      state.gender = userData.gender
      state.sourceId = userData.sourceId
      mixpanel.identify(state.sourceId)
      mixpanel.people.set({
        customer_gender: state.gender.toLowerCase(),
      })
      addDatadogGlobalContext({ key: 'userId', value: state.userId })
    }
  },
}
export const getters = {
  isLoggedIn: state => !!state.token,
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
}
